<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="/">poe.watch</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav id="navitems">
          <b-link to="/">Home</b-link>
          <b-link
            href="https://github.com/Mxrk/tracker-poe/issues"
            target="_blank"
            >bug/feature tracker</b-link
          >
          <b-link href="https://docs.poe.watch" target="_blank"
            >Api docs</b-link
          >
          <b-link to="Account">Account</b-link>
          <b-link to="Leagues">Leagues</b-link>
          <b-link to="Ladder">Ladder</b-link>
          <b-link href="https://discord.gg/fpnmfz3" target="_blank"
            >Discord</b-link
          >
          <b-link to="donation">Support</b-link>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form id="form">
            <globalSearch :league="this.$parent.league"> </globalSearch>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import globalSearch from "../components/globalSearch";
export default {
  name: "Navbar",
  props: {
    msg: String,
  },
  components: {
    globalSearch,
  },
  data() {
    return {
      filtered: [],
      search: "",
    };
  },
  mounted() {},
  methods: {
    forward(data) {
      this.search = "";
      this.$router.push({ name: data.page, params: { search: data.search } });
    },
  },
};
</script>

<style lang="scss">
body {
  width: 100%;
}
#form {
  width: 300px;
}
#navitems a {
  margin-left: 20px;
}

.form-control {
  background-color: #22262b;
  border-color: transparent;
}
.form-control:focus {
  background-color: #22262b;
  border-color: transparent;
}
</style>
